// Mother NPC portrait (monorail-x76) — a stroke-drawn pen-sketch ink bust for
// the JRPG dialog box. Same recipe as ui/skill-icons.ts: currentColor stroke,
// round caps, deliberately asymmetric paths so it reads as hand-drawn, not
// icon-font geometry. Echoes her in-game morphology (world.ts ~102): a
// bottom-heavy pear blob, mismatched reading-glasses eyes (right lens bigger),
// a hem frill. Warm and matronly — never ominous (hard project rule).

/** Inline SVG markup for the Mother's dialog portrait; sized by CSS. */
export function motherPortraitSvg(): string {
  const paths = `
    <!-- Bottom-heavy pear bust: narrow crown, wide skirt, a touch lopsided. -->
    <path d="M24 6 C30 6, 34.5 10.5, 35.5 17 C36.4 22.5, 39 27.5, 38.5 33
             C38 38.5, 32 41.5, 24 41.5 C15.5 41.5, 9.6 38.2, 9.4 32.8
             C9.2 27.5, 11.8 22.6, 12.7 17 C13.7 10.6, 18 6, 24 6 Z"/>
    <!-- Reading glasses: two lenses + bridge, right lens larger (asymmetric). -->
    <circle cx="18.2" cy="19.5" r="3.6"/>
    <circle cx="29.5" cy="20.4" r="4.9"/>
    <path d="M21.6 18.9 C22.8 18.1, 23.9 18.2, 24.7 19.1"/>
    <!-- Temple arm curling back toward the ear. -->
    <path d="M34.3 19.4 C36 18.8, 36.8 19.6, 36.6 21"/>
    <!-- A small warm smile, off-centre. -->
    <path d="M19.5 28.5 C22 31, 26.5 31, 29 28"/>
    <!-- Hem frill: a scalloped skirt edge along the bottom. -->
    <path d="M12.5 37 C14 39, 16 39, 17.4 37 C18.8 39, 20.8 39, 22.2 37
             C23.6 39, 25.6 39, 27 37 C28.4 39, 30.4 39, 31.8 37
             C33.2 39, 35 39, 36 37"/>`
  return `<svg viewBox="0 0 48 48" fill="none" stroke="currentColor"
    stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"
    aria-hidden="true">${paths}</svg>`
}
